import { render, staticRenderFns } from "./orgCert.vue?vue&type=template&id=64b55fc1&scoped=true"
import script from "./orgCert.vue?vue&type=script&lang=js"
export * from "./orgCert.vue?vue&type=script&lang=js"
import style0 from "./orgCert.vue?vue&type=style&index=0&id=64b55fc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b55fc1",
  null
  
)

export default component.exports